'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StoresQuadGooglePlay = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                fillRule: "evenodd",
                d: "M4.369 41.972v1.191h2.846c-.066.662-.33 1.192-.662 1.522-.397.398-1.059.86-2.184.86-1.787 0-3.111-1.39-3.111-3.176 0-1.788 1.39-3.178 3.11-3.178.927 0 1.656.398 2.185.86l.86-.86C6.687 38.53 5.76 38 4.436 38 2.052 38 0 39.986 0 42.369s2.052 4.368 4.435 4.368c1.324 0 2.25-.397 3.045-1.257.794-.795 1.059-1.92 1.059-2.78 0-.265 0-.53-.066-.729zm7.347-.861c-1.588 0-2.846 1.191-2.846 2.846a2.825 2.825 0 0 0 2.846 2.846c1.589 0 2.847-1.191 2.847-2.846 0-1.72-1.258-2.846-2.847-2.846m3.31 2.846c0-1.655 1.258-2.846 2.846-2.846s2.846 1.125 2.846 2.846c0 1.655-1.257 2.846-2.846 2.846a2.825 2.825 0 0 1-2.846-2.846m1.257-.066c0 .993.728 1.721 1.589 1.721.86 0 1.588-.728 1.588-1.72 0-1.06-.728-1.722-1.588-1.722s-1.589.728-1.589 1.721m-6.156 0c0 .993.728 1.721 1.589 1.721.86 0 1.589-.728 1.589-1.72 0-1.06-.729-1.722-1.59-1.722-.86 0-1.588.728-1.588 1.721m21.91-2.78c1.457 0 2.119 1.125 2.384 1.787l.132.331-3.773 1.589c.33.595.728.86 1.39.86s1.06-.33 1.39-.794l.927.662c-.265.463-1.06 1.258-2.317 1.258-1.589 0-2.78-1.258-2.78-2.847 0-1.72 1.191-2.846 2.648-2.846m-1.455 2.714c0-1.06.86-1.655 1.456-1.655.463 0 .927.265 1.059.596zm-1.854 2.714H27.47v-8.274h1.258zm-3.244-4.832c-.33-.331-.86-.662-1.522-.662-1.39 0-2.714 1.258-2.714 2.846s1.257 2.78 2.714 2.78c.662 0 1.191-.33 1.456-.662h.066v.398c0 1.059-.596 1.654-1.522 1.654-.728 0-1.258-.53-1.39-.993l-1.06.464c.331.728 1.126 1.655 2.516 1.655 1.456 0 2.648-.86 2.648-2.913v-5.03h-1.192zM22.44 43.89c0 .993.728 1.721 1.589 1.721.86 0 1.522-.728 1.522-1.72 0-.994-.662-1.722-1.522-1.722s-1.589.728-1.589 1.721m17.74-5.626H37.2v8.274h1.258v-3.111h1.721c1.39 0 2.714-.993 2.714-2.582s-1.324-2.581-2.714-2.581m-1.722 3.971h1.787c.86 0 1.39-.728 1.456-1.456 0-.596-.53-1.39-1.456-1.39h-1.787zm9.4-1.191c-.927 0-1.853.397-2.184 1.258l1.125.463c.265-.463.662-.596 1.125-.596.662 0 1.258.397 1.324 1.06v.065c-.198-.132-.728-.33-1.258-.33-1.191 0-2.383.661-2.383 1.853 0 1.125.993 1.853 2.052 1.853.86 0 1.258-.397 1.589-.794h.066v.662h1.192v-3.177c-.133-1.457-1.258-2.317-2.648-2.317m-1.126 3.839c0 .53.596.728.993.728.662 0 1.324-.53 1.456-1.324l-.098-.04c-.289-.117-.55-.224-1.027-.224-.596 0-1.324.198-1.324.86m7.944-3.64-1.39 3.574h-.066l-1.456-3.575H50.44l2.184 5.03-1.258 2.781h1.258L56 41.244zm-9.863 5.295h-1.258v-8.274h1.258z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GooglePlay_svg__paint0_linear_966_1784)",
                d: "M17.525 5.345c-.315.315-.525.84-.525 1.47v23.202c0 .63.21 1.155.525 1.47l.105.105 13.018-13.019v-.21z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GooglePlay_svg__paint1_linear_966_1784)",
                d: "m34.953 22.983-4.305-4.305v-.315l4.305-4.304.105.105 5.144 2.94c1.47.84 1.47 2.204 0 3.044z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GooglePlay_svg__paint2_linear_966_1784)",
                d: "m35.056 22.878-4.41-4.41-13.123 13.124c.525.525 1.26.525 2.205.105z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GooglePlay_svg__paint3_linear_966_1784)",
                d: "M35.056 14.06 19.728 5.344c-.945-.525-1.68-.42-2.205.105L30.647 18.47z"
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GooglePlay_svg__paint0_linear_966_1784",
                        x1: 24.912,
                        x2: 4.053,
                        y1: -10.327,
                        y2: -4.687,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#00A0FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.007,
                                stopColor: "#00A1FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.26,
                                stopColor: "#00BEFF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.512,
                                stopColor: "#00D2FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.76,
                                stopColor: "#00DFFF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#00E3FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GooglePlay_svg__paint1_linear_966_1784",
                        x1: 42.128,
                        x2: 16.724,
                        y1: 7.832,
                        y2: 7.832,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#FFE000"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.409,
                                stopColor: "#FFBD00"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.775,
                                stopColor: "#FFA500"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#FF9C00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GooglePlay_svg__paint2_linear_966_1784",
                        x1: 17.19,
                        x2: 0.429,
                        y1: 11.659,
                        y2: 39.8,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#FF3A44"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#C31162"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GooglePlay_svg__paint3_linear_966_1784",
                        x1: 7.321,
                        x2: 14.747,
                        y1: 1.754,
                        y2: 14.338,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#32A071"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.069,
                                stopColor: "#2DA771"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.476,
                                stopColor: "#15CF74"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.801,
                                stopColor: "#06E775"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#00F076"
                            })
                        ]
                    })
                ]
            })
        ]
    })));

export { StoresQuadGooglePlay, StoresQuadGooglePlay as default };
//# sourceMappingURL=StoresQuadGooglePlay.js.map
